import { AxiosMethod } from "../entities/Environment";
import request from "../axios/axios";
import type {  AxiosRequestConfig } from "axios";
import { CommonResponseInterface } from "../entities/Common";
import { CategoryInterface } from "../entities/Category";

export enum CategoryEndpoints {
  CATEGORY = "category",
}

export class CategoryService {
  static getCategories(
    config?: AxiosRequestConfig,
  ): Promise<CommonResponseInterface<CategoryInterface>> {
    return request({
      url: CategoryEndpoints.CATEGORY,
      method: AxiosMethod.GET,
      params: config?.params,
    });
  }

  static getCategory(id: string): Promise<CategoryInterface> {
    return request({
      url: `${CategoryEndpoints.CATEGORY}/${id}`,
      method: AxiosMethod.GET,
    });
  }
}
